export default {
  // 关闭底部导航栏
  BOTTOM(state, index) {
    state.bottom = index
  },
}